import { j as e } from "../../../_virtual/jsx-runtime.js";
import { useState as c } from "react";
import i from "styled-components";
import a from "../Input.js";
import { Form as t, message as o } from "antd";
import x from "../Button.js";
import P from "./comps/Success.js";
import y from "../../asset/icon/back.svg.js";
import { useNavigate as v } from "react-router-dom";
import { genVerificationCode as j, resetPassword as S } from "../../api/auth/index.js";
function $(m) {
  console.log("ForgotPassword component rendered", m);
  const [n] = t.useForm(), [p, u] = c(!1), [f, l] = c(!1), h = v();
  if (p)
    return /* @__PURE__ */ e.jsx(P, { title: "Setup Successful!", description: "Jumping to the login page for you" });
  const g = async () => {
    const r = n.getFieldValue("email");
    if (!r)
      return o.error("Please enter your email address"), !1;
    try {
      const s = await j(r);
      return s.code === 0 ? (o.success("Verification code sent to your email"), !0) : (o.error(s.message), !1);
    } catch {
      return o.error("Failed to send verification code"), !1;
    }
  }, w = async () => {
    const r = await n.validateFields();
    if (r.password !== r.confirmPassword) {
      o.error("Passwords do not match");
      return;
    }
    l(!0);
    try {
      const s = await S({
        email: r.email,
        password: r.password,
        code: r.code
      });
      if (s.code === 0)
        o.success("Password reset successfully"), u(!0);
      else {
        o.error(s.message), l(!1);
        return;
      }
      h("/login", { replace: !0 });
    } catch {
      o.error("Password reset failed"), l(!1);
    }
  };
  return /* @__PURE__ */ e.jsxs(b, { children: [
    /* @__PURE__ */ e.jsxs(F, { onClick: () => window.location.replace("/login"), children: [
      /* @__PURE__ */ e.jsx(y, {}),
      /* @__PURE__ */ e.jsx("span", { children: "Back" })
    ] }),
    /* @__PURE__ */ e.jsx(z, { children: "Reset your password" }),
    /* @__PURE__ */ e.jsx(C, { children: "Please confirm that you are trying to log in." }),
    /* @__PURE__ */ e.jsxs(t, { form: n, onFinish: w, children: [
      /* @__PURE__ */ e.jsx(
        t.Item,
        {
          name: "email",
          rules: [
            { required: !0, message: "Please input your email!" },
            { type: "email", message: "Please enter a valid email!" }
          ],
          children: /* @__PURE__ */ e.jsx(a, { placeholder: "Enter email address", label: "Email Address" })
        }
      ),
      /* @__PURE__ */ e.jsx(t.Item, { name: "code", rules: [{ required: !0, message: "Please input verification code!" }], children: /* @__PURE__ */ e.jsx(a, { placeholder: "Enter the code", variant: "verification", label: "Verification Code", onSendCode: g }) }),
      /* @__PURE__ */ e.jsx(
        t.Item,
        {
          name: "password",
          rules: [
            { required: !0, message: "Please input your password!" },
            {
              pattern: /^[a-zA-Z0-9]{8,25}$/,
              message: "Please enter the correct password!"
            }
          ],
          children: /* @__PURE__ */ e.jsx(a, { label: "Password", placeholder: "Use 8-25 English letters and numbers", variant: "password" })
        }
      ),
      /* @__PURE__ */ e.jsx(
        t.Item,
        {
          name: "confirmPassword",
          rules: [
            { required: !0, message: "Please confirm your password!" },
            {
              pattern: /^[a-zA-Z0-9]{8,25}$/,
              message: "Please enter the correct password!"
            },
            ({ getFieldValue: r }) => ({
              validator(s, d) {
                return !d || r("password") === d ? Promise.resolve() : Promise.reject(new Error("Passwords do not match!"));
              }
            })
          ],
          children: /* @__PURE__ */ e.jsx(a, { label: "Confirm Password", placeholder: "Please enter your password again", variant: "password" })
        }
      ),
      /* @__PURE__ */ e.jsx(x, { type: "primary", htmlType: "submit", loading: f, style: { width: "100%", height: "52px", fontSize: 18, fontWeight: 500 }, children: "Reset Password" })
    ] })
  ] });
}
const b = i.div`
  width: 100%;
  height: 100%;
  @media (max-width: 768px) {
    width: 100%;
    height: 100vh;
    padding-top: 24px;
  }
`, F = i.div`
  display: flex;
  align-items: center;
  gap: 8px;
  cursor: pointer;
  font-family: 'Poppins', sans-serif;
  font-size: 16px;
  font-weight: 400;
  color: var(--color-text);

  &:hover {
    opacity: 0.7;
  }
`, z = i.div`
  font-family: 'Poppins', sans-serif;
  font-weight: 500;
  font-size: 24px;
  color: var(--color-text);
  margin-top: 24px;
  margin-bottom: 20px;
`, C = i.div`
  font-family: 'Poppins', sans-serif;
  font-weight: 400;
  font-size: 16px;
  color: var(--color-text-07);
  margin-bottom: 32px;
`;
export {
  $ as default
};
